module.exports = __webpack_public_path__ + "static/media/1014979.5aed2557.jpg";